__turbopack_context__.v({
  "app_light_theme": "expandable-items-module-scss-module__gUx9pa__app_light_theme",
  "expanded": "expandable-items-module-scss-module__gUx9pa__expanded",
  "hasOverflow": "expandable-items-module-scss-module__gUx9pa__hasOverflow",
  "list": "expandable-items-module-scss-module__gUx9pa__list",
  "showMobileScrollBar": "expandable-items-module-scss-module__gUx9pa__showMobileScrollBar",
  "toggle": "expandable-items-module-scss-module__gUx9pa__toggle",
  "wrap": "expandable-items-module-scss-module__gUx9pa__wrap",
});
